export class InvolvedAssigner {
    $id: string;
    InvolvedPersonID: number;
    CaseID: number;
    FromEis: boolean;
    ChangeableTC: string;
    PersonTypeTC: string;
    Name: string;
    PrefixName?: any;
    Initials?: any;
    Telephone: string;
    TelephoneWork?: any;
    TelephoneMobile?: any;
    BirthDate?: any;
    GenderTC?: any;
    LegalFormTC: string;
    BankAccount?: any;
    Comment?: any;
    EmailAddress?: any;
    PreferredContactTime?: any;
    PreferredContactMethodTC?: any;
    Address1: string;
    Address2: string;
    Address5?: any;
    Address3: string;
    Address4: string;
    CountryTC: string;
    IBAN?: any;
    BIC?: any;
    Language?: any;
    BankAccountFor?: any;
    Occupation?: any;
    ToName?: any;
    CreatedDate: Date;
    CreatedByUserId?: any;

    public constructor(init?: Partial<InvolvedAssigner>) {
        Object.assign(this, init);
    }
}
